import BuildingType from "@/roc/building/BuildingType";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const MongolianMotherTree = {
  id: "79",
  name: "Mongolian Mother Tree",
  width: 4,
  height: 3,
  type: BuildingType.EVENT,
  era: "stoneAge",
  icon: "Mongolian_Mother_Tree",
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Mongolian_Mother_Tree',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.CAVALRY_HIT_POINT_MOD,
      EffectAmount.asPerLevel([
        1.00, 1.13, 1.25, 1.38, 1.50, 1.63, 1.75, 1.88, 2.00, 2.00,
        2.25, 2.38, 2.50, 2.63, 2.63, 2.88, 3.00, 3.13, 3.25, 3.25,
        3.50, 3.50, 3.75, 3.88, 4.00, 4.13, 4.25, 4.38, 4.50, 4.50,
        4.75, 4.88, 5.00, 5.13, 5.13, 5.38, 5.50, 5.63, 5.75, 5.75,
        6.00, 6.00, 6.25, 6.38, 6.50, 6.63, 6.75, 6.88, 7.00, 7.00,
        7.25, 7.38, 7.50, 7.63, 7.63, 7.88, 8.00, 8.13, 8.25, 8.25,
      ]),
      '%',
    ),
    new CultureBonus(
      CultureAmount.asPerEraAndLevel({
        stoneAge: [
          13,16,19,22,25,28,31,34,37,40,43,46,49,52,55,58,61,64,67,70,73,76,79,82,85,88,91,94,97,100,103,106,109,112,115,118,121,124,127,130,133,136,139,142,145,148,151,154,157,160,163,166,169,172,175,178,181,184,187,190
        ],
        bronzeAge: [
          24,28,32,36,40,44,48,52,56,60,64,68,72,76,80,84,88,92,96,100,104,108,112,116,120,124,128,132,136,140,144,148,152,156,160,164,168,172,176,180,184,188,192,196,200,204,208,212,216,220,224,228,232,236,240,244,248,252,256,260
        ],
        minoanEra: [
          35,40,45,50,55,60,65,70,75,80,85,90,95,100,105,110,115,120,125,130,135,140,145,150,155,160,165,170,175,180,185,190,195,200,205,210,215,220,225,230,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330
        ],
        classicGreece: [
          46,52,58,64,70,76,82,88,94,100,106,112,118,124,130,136,142,148,154,160,166,172,178,184,190,196,202,208,214,220,226,232,238,244,250,256,262,268,274,280,286,292,298,304,310,316,322,328,334,340,346,352,358,364,370,376,382,388,394,400
        ],
        earlyRome: [
          57,64,71,78,85,92,99,106,113,120,127,134,141,148,155,162,169,176,183,190,197,204,211,218,225,232,239,246,253,260,267,274,281,288,295,302,309,316,323,330,337,344,351,358,365,372,379,386,393,400,407,414,421,428,435,442,449,456,463,470
        ],
        romanEmpire: [
          68,76,84,92,100,108,116,124,132,140,148,156,164,172,180,188,196,204,212,220,228,236,244,252,260,268,276,284,292,300,308,316,324,332,340,348,356,364,372,380,388,396,404,412,420,428,436,444,452,460,468,476,484,492,500,508,516,524,532,540
        ],
        byzantineEra: [
          79,88,97,106,115,124,133,142,151,160,169,178,187,196,205,214,223,232,241,250,259,268,277,286,295,304,313,322,331,340,349,358,367,376,385,394,403,412,421,430,439,448,457,466,475,484,493,502,511,520,529,538,547,556,565,574,583,592,601,610
        ],
        ageOfTheFranks: [
          90,100,110,120,130,140,150,160,170,180,190,200,210,220,230,240,250,260,270,280,290,300,310,320,330,340,350,360,370,380,390,400,410,420,430,440,450,460,470,480,490,500,510,520,530,540,550,560,570,580,590,600,610,620,630,640,650,660,670,680
        ],
        feudalAge: [
          101,112,123,134,145,156,167,178,189,200,211,222,233,244,255,266,277,288,299,310,321,332,343,354,365,376,387,398,409,420,431,442,453,464,475,486,497,508,519,530,541,552,563,574,585,596,607,618,629,640,651,662,673,684,695,706,717,728,739,750
        ],
        iberianEra: [
          112,124,136,148,160,172,184,196,208,220,232,244,256,268,280,292,304,316,328,340,352,364,376,388,400,412,424,436,448,460,472,484,496,508,520,532,544,556,568,580,592,604,616,628,640,652,664,676,688,700,712,724,736,748,760,772,784,796,808,820
        ],
        kingdomOfSicily: [
          123,136,149,162,175,188,201,214,227,240,253,266,279,292,305,318,331,344,357,370,383,396,409,422,435,448,461,474,487,500,513,526,539,552,565,578,591,604,617,630,643,656,669,682,695,708,721,734,747,760,773,786,799,812,825,838,851,864,877,890
        ],
        highMiddleAges: [
          134,148,162,176,190,204,218,232,246,260,274,288,302,316,330,344,358,372,386,400,414,428,442,456,470,484,498,512,526,540,554,568,582,596,610,624,638,652,666,680,694,708,722,736,750,764,778,792,806,820,834,848,862,876,890,904,918,932,946,960
        ],
        earlyGothicEra: [
          145,160,175,190,205,220,235,250,265,280,295,310,325,340,355,370,385,400,415,430,445,460,475,490,505,520,535,550,565,580,595,610,625,640,655,670,685,700,715,730,745,760,775,790,805,820,835,850,865,880,895,910,925,940,955,970,985,1000,1015,1030
        ],
        lateGothicEra: [
          156,172,188,204,220,236,252,268,284,300,316,332,348,364,380,396,412,428,444,460,476,492,508,524,540,556,572,588,604,620,636,652,668,684,700,716,732,748,764,780,796,812,828,844,860,876,892,908,924,940,956,972,988,1004,1020,1036,1052,1068,1084,1100
        ]
      }),
      CultureRange.asPerLevel([
        1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2,
        2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
        3, 3, 3, 3, 3, 3, 3, 3, 3, 4,
      ]),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          112,120,128,136,144,152,160,168,176,184,192,200,208,216,224,232,240,248,256,264,272,280,288,296,304,312,320,328,336,344,352,360,368,376,384,392,400,408,416,424,432,440,448,456,464,472,480,488,496,504,512,520,528,536,544,552,560,568,576,584
        ],
        bronzeAge: [
          125,134,143,152,161,170,179,188,197,206,215,224,233,242,251,260,269,278,287,296,305,314,323,332,341,350,359,368,377,386,395,404,413,422,431,440,449,458,467,476,485,494,503,512,521,530,539,548,557,566,575,584,593,602,611,620,629,638,647,656
        ],
        minoanEra: [
          138,148,158,168,178,188,198,208,218,228,238,248,258,268,278,288,298,308,318,328,338,348,358,368,378,388,398,408,418,428,438,448,458,468,478,488,498,508,518,528,538,548,558,568,578,588,598,608,618,628,638,648,658,668,678,688,698,708,718,728
        ],
        classicGreece: [
          151,162,173,184,195,206,217,228,239,250,261,272,283,294,305,316,327,338,349,360,371,382,393,404,415,426,437,448,459,470,481,492,503,514,525,536,547,558,569,580,591,602,613,624,635,646,657,668,679,690,701,712,723,734,745,756,767,778,789,800
        ],
        earlyRome: [
          164,176,188,200,212,224,236,248,260,272,284,296,308,320,332,344,356,368,380,392,404,416,428,440,452,464,476,488,500,512,524,536,548,560,572,584,596,608,620,632,644,656,668,680,692,704,716,728,740,752,764,776,788,800,812,824,836,848,860,872
        ],
        romanEmpire: [
          177,190,203,216,229,242,255,268,281,294,307,320,333,346,359,372,385,398,411,424,437,450,463,476,489,502,515,528,541,554,567,580,593,606,619,632,645,658,671,684,697,710,723,736,749,762,775,788,801,814,827,840,853,866,879,892,905,918,931,944
        ],
        byzantineEra: [
          190,204,218,232,246,260,274,288,302,316,330,344,358,372,386,400,414,428,442,456,470,484,498,512,526,540,554,568,582,596,610,624,638,652,666,680,694,708,722,736,750,764,778,792,806,820,834,848,862,876,890,904,918,932,946,960,974,988,1002,1016
        ],
        ageOfTheFranks: [
          203,218,233,248,263,278,293,308,323,338,353,368,383,398,413,428,443,458,473,488,503,518,533,548,563,578,593,608,623,638,653,668,683,698,713,728,743,758,773,788,803,818,833,848,863,878,893,908,923,938,953,968,983,998,1013,1028,1043,1058,1073,1088
        ],
        feudalAge: [
          216,232,248,264,280,296,312,328,344,360,376,392,408,424,440,456,472,488,504,520,536,552,568,584,600,616,632,648,664,680,696,712,728,744,760,776,792,808,824,840,856,872,888,904,920,936,952,968,984,1000,1016,1032,1048,1064,1080,1096,1112,1128,1144,1160
        ],
        iberianEra: [
          229,246,263,280,297,314,331,348,365,382,399,416,433,450,467,484,501,518,535,552,569,586,603,620,637,654,671,688,705,722,739,756,773,790,807,824,841,858,875,892,909,926,943,960,977,994,1011,1028,1045,1062,1079,1096,1113,1130,1147,1164,1181,1198,1215,1232
        ],
        kingdomOfSicily: [
          242,260,278,296,314,332,350,368,386,404,422,440,458,476,494,512,530,548,566,584,602,620,638,656,674,692,710,728,746,764,782,800,818,836,854,872,890,908,926,944,962,980,998,1016,1034,1052,1070,1088,1106,1124,1142,1160,1178,1196,1214,1232,1250,1268,1286,1304
        ],
        highMiddleAges: [
          255,274,293,312,331,350,369,388,407,426,445,464,483,502,521,540,559,578,597,616,635,654,673,692,711,730,749,768,787,806,825,844,863,882,901,920,939,958,977,996,1015,1034,1053,1072,1091,1110,1129,1148,1167,1186,1205,1224,1243,1262,1281,1300,1319,1338,1357,1376
        ],
        earlyGothicEra: [
          268,288,308,328,348,368,388,408,428,448,468,488,508,528,548,568,588,608,628,648,668,688,708,728,748,768,788,808,828,848,868,888,908,928,948,968,988,1008,1028,1048,1068,1088,1108,1128,1148,1168,1188,1208,1228,1248,1268,1288,1308,1328,1348,1368,1388,1408,1428,1448
        ],
        lateGothicEra: [
          281,302,323,344,365,386,407,428,449,470,491,512,533,554,575,596,617,638,659,680,701,722,743,764,785,806,827,848,869,890,911,932,953,974,995,1016,1037,1058,1079,1100,1121,1142,1163,1184,1205,1226,1247,1268,1289,1310,1331,1352,1373,1394,1415,1436,1457,1478,1499,1520
        ]
      }).withOutput(ProductionOutputType.RANDOM_CURRENT_ERA_GOODS),
    ),
  ]),
};

export default MongolianMotherTree;
